export default __webpack_public_path__ + "static/media/jcb.d279631c.svg";